import { createContext, useContext } from "react";

/**
 * True when the consumer is rendered inside a <FunnelModal>'s funnelBody.
 * Used by components like StickyPurchaseButton to decide whether they may
 * portal into `gcModalContentContainer`.
 *
 * Without this flag StickyPurchaseButton would happily portal whenever the
 * container exists — leaking a page-level CTA (e.g. the /gold paywall's
 * Subscribe button) into whatever unrelated modal happened to be open at
 * the time (claim-username, signup, etc).
 */
export const FunnelModalContext = createContext<boolean>(false);

export function useIsInsideFunnelModal(): boolean {
  return useContext(FunnelModalContext);
}
